// extracted by mini-css-extract-plugin
export default {"ge":"ge__WOtuZ","hide":"hide__mwj6Q"};